module.exports = __webpack_public_path__ + "img/folder.81ed95d4.svg";